angular.module("ainapp")
    .controller("leaveReportSummaryController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Leave Report Summary";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {


                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

                $scope.filter = {
                    VoucherNo: "",
                    EmployeeIds: [],
                    FromDate: startdate,
                    ToDate: new Date(),
                    BranchId: "",
                }

                $scope.load = false;
                $scope.isFilter = false;

            }
            $scope.Init();


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                        o.data.FromDay = $scope.filter.FromDate.getDate();
                        o.data.FromYear = $scope.filter.FromDate.getFullYear();
                        o.data.AccountIds = $scope.filter.AccountIds;

                        o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                        o.data.ToDay = $scope.filter.ToDate.getDate();
                        o.data.ToYear = $scope.filter.ToDate.getFullYear();

                        o.data.EmployeeIds = $scope.filter.EmployeeIds;


                        MainService.EmployeeLeaveReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {
                    if (data.items.length > 0) {
                        data.sender._aggregateResult.Balance.count = 0;
                        angular.forEach(data.items, function (e) {
                            e.aggregates.Balance.count = Math.abs(e.aggregates.Assigned.sum - e.aggregates.Applied.sum);
                            e.aggregates.Balance.count = Math.round(e.aggregates.Balance.count * 100) / 100;
                        })
                        data.sender._aggregateResult.Balance.count = Math.abs(data.sender._aggregateResult.Assigned.sum - data.sender._aggregateResult.Applied.sum);
                        data.sender._aggregateResult.Balance.count = Math.round(data.sender._aggregateResult.Balance.count * 100) / 100;
                    }
                },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },
                            "PayrollComponent.Name": {
                                type: "string",
                                editable: false,
                            },
                            Applied: {
                                type: "number",
                                editable: false,
                            },
                            Assigned: {
                                type: "number",
                                editable: false,
                            },
                            Balance: {
                                type: "number",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },


                        }
                    }
                },

                group: [{
                    field: "PayrollComponent.Name",
                    aggregates: [
                        {
                            field: "Applied",
                            aggregate: "sum"
                            },
                        {
                            field: "Assigned",
                            aggregate: "sum"
                            },
                        {
                            field: "Balance",
                            aggregate: "count"
                            }
                        ]
                    }],
                aggregate: [{
                        field: "Applied",
                        aggregate: "sum"
                            },
                    {
                        field: "Assigned",
                        aggregate: "sum"
                            },
                    {
                        field: "Balance",
                        aggregate: "count"
                            }],

                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "PayrollComponent.Name",
                        title: "Leave Type",
                        hidden: true,
                        headerTemplate: "{{LanguageData.LeaveType}}",
                        },
                    {
                        field: "Employee.Name",
                        title: "Employee",

                        headerTemplate: "{{LanguageData.Employee}}",

                        },

                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        headerTemplate: "{{LanguageData.Date}}",

                        },
                    {
                        field: "Assigned",
                        title: "Assigned",
                        template: "<div  style='text-align: right'>#=kendo.toString(Assigned, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: "{{LanguageData.Assigned}}",

                        },
                    {
                        field: "Applied",
                        title: "Applied",
                        template: "<div  style='text-align: right'>#=kendo.toString(Applied, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: "{{LanguageData.Applied}}",

                        },
                    {
                        field: "Balance",
                        title: "Balance",
                        template: "<div  style='text-align: right'>#=kendo.toString(Balance, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(count, 'n')#",
                        footerTemplate: "#=kendo.toString(count, 'n')#",
                        headerTemplate: "{{LanguageData.Balance}}",
                        },
//                    {
//                        title: "Options",
//                        headerTemplate: "{{LanguageData.Options}}  ",
//                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button>",
//                        width: '80px'
//                    },
                    ],
            };

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }



            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

                }])
